import { Button, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import Gad7Card from "./components/Gad7Card";
import { useIsMobile } from "src/hooks/useIsMobile";
import WhiteCard from "src/shared/components/WhiteCard";
import Phq9Card from "./components/Phq9Card";
import { useQuestions } from "src/context/QuestionsProvider";

interface Props {
  onNext: () => void;
}

const AmhReview = ({ onNext }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const page = "amh-review";
  const title = useQuestions((q) => q.title);

  return (
    <Stack gap={2}>
      <Typography variant="h4">{title}</Typography>
      <Typography variant="subtitle1" fontSize={"1.1rem"}>
        {t(
          `${page}.subheader`,
          "These results help your provider choose the most effective plan for you."
        )}
      </Typography>
      <Gad7Card onNavigate={onNext} />
      <WhiteCard
        gap={1}
        sx={{
          borderRadius: "30px",
          background: `linear-gradient(
        180deg,
        rgba(0, 182, 185, 0.75) 0.31%,
        rgba(255, 255, 255, 0.36) 99.69%
      ),
      #00B6B9`,
          padding: "40px",
        }}
        onClick={onNext}
      >
        <Typography color="#ffffff">
          {t(`${page}.subcard-1.caption`, "Common anxiety symptoms")}
        </Typography>
        <Typography color="#ffffff" variant="h6" fontWeight={600}>
          {t(
            `${page}.subcard-1.text`,
            "feeling nervous, overthinking, trouble relaxing"
          )}
        </Typography>
      </WhiteCard>
      <Button
        sx={{ borderRadius: "30px", height: "65px", padding: 2 }}
        onClick={onNext}
      >
        <Typography
          variant={isMobile ? "body1" : "h6"}
          color="#ffffff"
          fontWeight={600}
        >
          {t(`${page}.continue`, "Continue to receive your plan")}
        </Typography>
      </Button>
      <Phq9Card onNavigate={onNext} />
      <WhiteCard
        gap={1}
        sx={{
          borderRadius: "30px",
          background: `linear-gradient(
        180deg,
        #79D2E8 0.31%,
        rgba(255, 255, 255, 0.36) 99.69%
      ),
      #79D2E8`,
          padding: "40px",
        }}
        onClick={onNext}
      >
        <Typography color="#ffffff">
          {t(`${page}.subcard-2.caption`, "Common depression symptoms")}
        </Typography>
        <Typography color="#ffffff" variant="h6" fontWeight={600}>
          {t(
            `${page}.subcard-2.text`,
            "feeling tired, losing interest, trouble finding motivation"
          )}
        </Typography>
      </WhiteCard>
      <Button
        sx={{ borderRadius: "30px", height: "65px", padding: 2 }}
        onClick={onNext}
      >
        <Typography
          variant={isMobile ? "body1" : "h6"}
          color="#ffffff"
          fontWeight={600}
        >
          {t(`${page}.continue`, "Continue to receive your plan")}
        </Typography>
      </Button>
    </Stack>
  );
};

export default AmhReview;
